import React, { Component } from "react";
import Lottie from "react-lottie";
import logoutJSON from "../json/logoutJSON.json";

class LogoutAnim extends Component {
  defaultOptions = {};

  constructor(props) {
    super(props);
    this.defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: logoutJSON,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
  }

  render() {
    return (
      <>
        <Lottie options={this.defaultOptions} />
      </>
    );
  }
}

export default LogoutAnim;
